import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleLegendSquare } from "./styled";
import { LegendSymbolType } from "./types";
import hexagon from "../../../../assets/images/hexagon.svg";
export const SimpleLegendSymbol = ({ type, opacity }) => {
    if (type === LegendSymbolType.Hexagon) {
        return _jsx("img", { src: hexagon, alt: "", height: "20px", style: { opacity } });
    }
    return _jsx(SimpleLegendSquare, { opacity: opacity });
};
